import { IconButton } from 'foundations-components/transitional/components/IconButton';
import I18n from 'I18n';
import { SettingsIcon } from 'foundations-assets';
import { useState } from 'react';
import { AI_INSIGHTS_SETTINGS_GATE } from '../../../../../constants/gates';
import { useGate } from '../../../../../hooks/useGate';
import { AISettings } from './AISettings';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AISettingsButton({
  report,
  reportResolve,
  onReportChange
}) {
  const isAIInsightsSettingsEnabled = useGate(AI_INSIGHTS_SETTINGS_GATE);
  const [isAISettingsModalOpen, setAISettingsModalOpen] = useState(false);
  const btnTitle = I18n.text('reporting-enablement.aiInsightsSettings.title');
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(report);
  if (!isAIInsightsSettingsEnabled) {
    return null;
  }
  function openSettings() {
    setAISettingsModalOpen(true);
    trackAIInsightsEvent({
      action: 'openSettings'
    });
  }
  function onClose(updatedReport) {
    setAISettingsModalOpen(false);
    if (updatedReport) {
      onReportChange(updatedReport);
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      size: "extra-small",
      onClick: openSettings,
      tooltip: btnTitle,
      "aria-label": btnTitle,
      "data-test-id": "ai-settings-button",
      children: /*#__PURE__*/_jsx(SettingsIcon, {
        size: "100"
      })
    }), isAISettingsModalOpen && /*#__PURE__*/_jsx(AISettings, {
      report: report,
      reportResolve: reportResolve,
      onClose: onClose
    })]
  });
}